var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-course"},[_c('p',{staticClass:"title"},[_vm._v("推荐课程")]),_c('OrgCourseCard',{attrs:{"courseInfo":_vm.courseInfo,"showOrgInfo":false,"needAdaptStyle":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }